<template>
  <button class="open-map-btn" @click="onClick">查看地图</button>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";
import { useSceneSession } from "../../../hooks/useSceneSession";
import { useRoute, useRouter } from "vue-router";
import { AI_CHAT_ROLE } from "../../../../../../constants/ai";
const props = defineProps({
  messageId: {
    type: String,
    default: "",
  },
});

const router = useRouter();
const route = useRoute();
const getScene = () => {
  return route.name === "ai-chat" ? "chat" : "deep-chat";
};
const [currentSession] = useSceneSession(getScene());
const getMessageContent = () => {
  const targetIndex = currentSession.value?.messages.findIndex(
    (message) =>
      message.id === props.messageId && message.role === AI_CHAT_ROLE.ASSISTANT
  );
  if (targetIndex === -1) return "";
  return currentSession.value.messages[targetIndex].content[0] || "";
};
const getMessageType = () => {
  const content = getMessageContent();
  if (content.includes("site-recommend")) return "select-store-report";
  if (content.includes("best-address-compare")) return "best-address-report";
  if (content.includes("business-recommend")) return "select-business-report";
  return "";
};
const hasMapJump = ref(false);
watch(
  () => props.content,
  () => {
    if (getMessageType()) {
      hasMapJump.value = true;
    }
  },
  {
    immediate: true,
  }
);
const onClick = () => {
  router.push({
    path: `/ai/map/${getMessageType()}`,
    query: {
      scene: getScene(),
      messageId: props.messageId,
    },
  });
};
</script>

<style lang="scss" scoped>
.open-map-btn {
  width: 100%;
  margin-top: 0.28rem;
  padding: 0.12rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #fff;
  background: #0057ff;
  border-radius: 0.32rem;
}
</style>
